/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import { CodeCircle24Regular, BoardHeart24Regular, ProjectionScreenText24Regular } from '@fluentui/react-icons';
import moment from 'moment';
import React from 'react';
import { InView } from 'react-intersection-observer';
import { Link, useNavigate } from 'react-router-dom';
import { getSvgIcon } from 'resources';
import AppDevelopment from 'scss/main/App.development.module.scss';
import AppStyle from 'scss/main/App.module.scss';
import AppProduction from 'scss/main/App.production.module.scss';
import { useGetListQuery } from 'services/blog.sevices';

const Home: React.FC<{}> = () => {

  const navigate = useNavigate();
  const { data } = useGetListQuery({ items: 3 });

  return (
    <div className={AppStyle['home']}>
      <div>
        <div>
          <InView triggerOnce>
            {({ inView, ref }) => (
              <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                <div>Full Stack Enginner</div>
              </div>
            )}
          </InView>
          <InView triggerOnce>
            {({ inView, ref }) => (
              <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                {<>
                  <div>I design and develop</div>
                  <div>Web and Mobile applications</div>
                  <div>that are SMART, PRACTICAL and AMAZING.</div>
                </>}
              </div>
            )}
          </InView>
          <InView triggerOnce>
            {({ inView, ref }) => (
              <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                <div>I design and develop Web and Mobile applications that are SMART, PRACTICAL and AMAZING.</div>
              </div>
            )}
          </InView>
          <div>
            <div />
          </div>
          <div>
            <div><div style={{ backgroundImage: `url('${process.env.REACT_APP_CDN_PATH}7cadf466539111ee8c990242ac120002.webp')` }} /><div /></div>
            <div><div style={{ backgroundImage: `url('${process.env.REACT_APP_CDN_PATH}14abb024539111ee8c990242ac120002.webp')` }} /><div /></div>
            <div>
              <div><div style={{ backgroundImage: `url('${process.env.REACT_APP_CDN_PATH}6ba53800539611ee8c990242ac120002.webp')` }} /><div /></div>
              <div><div style={{ backgroundImage: `url('${process.env.REACT_APP_CDN_PATH}a2c2967039611ee8c990242ac120002.webp')` }} /><div /></div>
            </div>
            <div><div style={{ backgroundImage: `url('${process.env.REACT_APP_CDN_PATH}b5eb7a92e3448b683493b7cd9cfa84ae5e50ec0b5dca9c321f4dc015ca5a41de.webp')` }} /><div /></div>
            <div><div style={{ backgroundImage: `url('${process.env.REACT_APP_CDN_PATH}fa291b96539611ee8c990242ac120002.webp')` }} /><div /></div>
          </div>
        </div>
      </div>
      <div>
        {
          data?.success && data?.results.length > 0 ? <div>
            <InView triggerOnce>
              {({ inView, ref, entry }) => (
                <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                  <div>Latest</div>
                  <div>Article</div>
                </div>
              )}
            </InView>
            <InView triggerOnce>
              {({ inView, ref, entry }) => (
                <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                  {
                    data?.success ?
                      data?.results?.map((d, i) => <div>
                        <div onClick={() => navigate(`blog/${d.aid}`)}>
                          {d.title}
                        </div>
                        <div>
                          {moment(d.created_time * 1000).format('MMM DD, YYYY')}
                        </div>
                      </div>)
                      : null
                  }
                  {
                    data?.results?.length > 0 && <div>
                      <div onClick={() => navigate(`blog`)}>More</div>
                    </div>
                  }
                </div>
              )}
            </InView>
          </div> : <noindex><div /></noindex>
        }
      </div>
      <div>
        <div>
          <div>
            <InView triggerOnce>
              {({ inView, ref, entry }) => (
                <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                  <div>Skill Sets</div>
                </div>
              )}
            </InView>
            <div>
              <div>
                <InView triggerOnce>
                  {({ inView, ref, entry }) => (
                    <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                      <div>4 Most Popular</div>
                      <div>Mobile App Platform & Technology</div>
                    </div>
                  )}
                </InView>
                <InView triggerOnce>
                  {({ inView, ref, entry }) => (
                    <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                      <div>3 Most Popular</div>
                      <div>Web App Platform & Technology</div>
                    </div>
                  )}
                </InView>
              </div>
              <div>
                <InView triggerOnce>
                  {({ inView, ref, entry }) => (
                    <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                      <div>11+ Popular Skills</div>
                      <div>Programming Language & Backend Technology</div>
                    </div>
                  )}
                </InView>
                <InView triggerOnce>
                  {({ inView, ref, entry }) => (
                    <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                      <div>13+</div>
                      <div>Powerful Projects</div>
                    </div>
                  )}
                </InView>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div>
            <div>
              GCP
            </div>
            <div>
              Development
            </div>
            <div>
              Azure
            </div>
            <div>
              FullStack
            </div>
            <div>
              AWS
            </div>
            <div>
              Engineer
            </div>
            <div>
              RDBMS
            </div>
            <div>
              UI
            </div>
            <div>
              NOSQL
            </div>
            <div>
              UX
            </div>
          </div>
          <div>
            <div>
              Android
            </div>
            <div>
              Java
            </div>
            <div>
              ReactNative
            </div>
            <div>
              Kotlin
            </div>
            <div>
              Flutter
            </div>
            <div>
              Dart
            </div>
            <div>
              iOS
            </div>
            <div>
              Swift
            </div>
          </div>
          <div>
            <div>
              Angular
            </div>
            <div>
              JavaScript
            </div>
            <div>
              React.js
            </div>
            <div>
              C#
            </div>
            <div>
              .NetCore
            </div>
            <div>
              TypeScript
            </div>
            <div>
              Vue.js
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          <InView triggerOnce>
            {({ inView, ref, entry }) => (
              <div className={`${inView && AppStyle['descAnimF']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'upquote' })}` }} />
            )}
          </InView>
          <InView triggerOnce>
            {({ inView, ref, entry }) => (
              <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                <div><div>I know what the result would be,</div></div>
                <div><div>but I still want to go there by myself</div></div>
                <div><div>because I wanted to see how it happened.</div></div>
              </div>
            )}
          </InView>
          <InView triggerOnce>
            {({ inView, ref, entry }) => (
              <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                <div><div>I know what the result would be, but I still want to go there by myself because I wanted to see how it happened.</div></div>
              </div>
            )}
          </InView>
          <InView triggerOnce>
            {({ inView, ref, entry }) => (
              <div className={`${inView && AppStyle['descAnimF']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'dnquote' })}` }} />
            )}
          </InView>
        </div>
      </div>
      <div>
        <InView triggerOnce>
          {({ inView, ref, entry }) => (
            <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
              <div>Who Am I?</div>
            </div>
          )}
        </InView>
        <InView triggerOnce>
          {({ inView, ref, entry }) => (
            <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
              <div>
                <div><CodeCircle24Regular /></div>
                <div>Programming</div>
                <div>With a rich background as a Full-Stack Engineer, I relish conquering intricate coding puzzles, crafting efficient, user-centric software. Fueled by a relentless desire for innovation, I persistently expand my expertise, proudly owning and delivering diverse projects.</div>
              </div>
              <div>
                <div><ProjectionScreenText24Regular /></div>
                <div>Experienced</div>
                <div>With a robust background in Full-Stack Engineering, I've masterminded 13+ diverse projects, from inception to execution. My role extends beyond coding, showcasing prowess in project management and independent ownership for successful outcomes.</div>
              </div>
              <div>
                <div><BoardHeart24Regular /></div>
                <div>Heart</div>
                <div>My life is a journey fueled by curiosity and an unquenchable thirst for challenge. Whether it's crafting code or embracing life's adventures, I'm always ready to explore and conquer new frontiers.</div>
              </div>
            </div>
          )}
        </InView>
        <InView triggerOnce>
          {({ inView, ref, entry }) => (
            <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
              <div>As an experienced Full-Stack Engineer with 6+ years of hands-on development experience, I thrive on tackling complex programming challenges and delivering efficient, scalable, and user-friendly software solutions. With a passion for programming and a drive for innovation, I am constantly pushing myself to learn and grow in my field.</div>
              <div>I am proud to have designed and developed over 13 software projects from ideation to production, showcasing my expertise in Project Management, Programming and other skills. My ability to work independently has allowed me to take on complete ownership of these projects, ensuring their successful delivery and implementation.</div>
              <div>I possess a strong understanding of both front-end and back-end development, as well as experience with various programming languages, tools, and frameworks. Whether it is developing custom software applications or troubleshooting complex technical issues, I am always eager to take on new challenges.</div>
              <div>If you think I can create new value for you and your company, please feel free to contact me.</div>
            </div>
          )}
        </InView>
        <div>
          <InView triggerOnce>
            {({ inView, ref, entry }) => (
              <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                <div className={`${AppStyle["skill-container-main-container-box-titlebox-btnbox-btn"]} ${AppStyle["buttonLine"]}`}>
                  <div>
                    <Link to='/skills'>
                      Learn More About Me
                      <div className={AppStyle["button-border"]} />
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </InView>
        </div>
      </div>
    </div>
  )
}

export default Home